import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { SeoServiceService } from 'src/app/services/seo-service.service';

@Component({
    selector: 'app-k12-digital-content-for-schools',
    templateUrl: './k12-digital-content-for-schools.component.html',
    styleUrls: ['./k12-digital-content-for-schools.component.scss']
})
export class K12DigitalContentForSchoolsComponent implements OnInit {

    constructor(
        private titleService: Title,
        private metaService: Meta,
        private seoService: SeoServiceService
    ) { }

    ngOnInit(): void {
        this.seoService.createLinkForCanonicalURL();
        this.titleService.setTitle('K–12 Digital Content for Schools | Interactive Learning Solutions by Virsa');
        this.metaService.updateTag({ name: 'description', content: 'Explore Virsa K–12 digital content covering Science, Maths, English, SST, Physics, Chemistry, and Biology with interactive learning, better results, and improved retention.' });
        this.metaService.updateTag({ name: 'keywords', content: 'K-12 digital content for schools, Digital learning content for students, Interactive content for schools India, K-12 e-learning solutions, Smart classroom content, Science digital content, Maths learning solutions, English digital learning, SST interactive content, Physics ,Chemistry ,Biology content, Virsa digital content' });
    }

}
